import { Modal, ModalContent } from '@heroui/modal';

import Spinner from './Spinner.tsx';

interface SpinnerOverlayProps {
  isOpen?: boolean;
}

function SpinnerOverlay({ isOpen = false }: SpinnerOverlayProps) {
  return (
    <Modal
      classNames={{
        closeButton: 'hidden',
        base: 'bg-transparent  outline-0',
      }}
      isOpen={isOpen}
      placement="center"
      shadow="none"
    >
      <ModalContent>
        {() => (
          <div className="text-foreground flex justify-center outline-0">
            <Spinner />
          </div>
        )}
      </ModalContent>
    </Modal>
  );
}

export default SpinnerOverlay;
